import { render, staticRenderFns } from "./DTEdit.vue?vue&type=template&id=16ff1127&"
import script from "./DTEdit.vue?vue&type=script&lang=js&"
export * from "./DTEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports